import React from 'react';
import { keyBy } from 'lodash';
import { AodOutlinedIcon, PhotoOutlinedIcon, VerticalSplitOutlinedIcon, ViewCarouselOutlinedIcon } from 'tuui';
import { FEATURE_FLAGS } from 'modules/taboola-common-frontend-modules/account-configurations';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { hasCampaignCreatives } from '../CarouselCardList/utils/hasCampaignCreatives';

export const CREATIVE_FORMAT_TYPE = {
    IMAGE_AND_MOTION_AD: 'IMAGE_AND_MOTION_AD',
    APP_INSTALL: 'APP_INSTALL',
    CAROUSEL: 'CAROUSEL',
    VERTICAL: 'VERTICAL',
    DISPLAY: 'DISPLAY',
};

export const formatTypes = [
    {
        id: CREATIVE_FORMAT_TYPE.APP_INSTALL,
        icon: AodOutlinedIcon,
        label: 'APP INSTALL',
        visibilityCondition: ({ renderAppInstallFormat }) => renderAppInstallFormat,
        subText: (
            <FormattedMessage
                id="creative.creator.ad.formats.app.ads.description"
                defaultMessage="Drive app promotion across networks and get more people to install your app"
            />
        ),
    },
    {
        id: CREATIVE_FORMAT_TYPE.IMAGE_AND_MOTION_AD,
        icon: PhotoOutlinedIcon,
        label: 'STANDARD',
        subText: (
            <FormattedMessage
                id="creative.creator.image.motion.format.type.description"
                defaultMessage="Upload horizontal/square static or motion media assets. No motion ad? Create one below."
            />
        ),
    },
    {
        id: CREATIVE_FORMAT_TYPE.CAROUSEL,
        icon: ViewCarouselOutlinedIcon,
        label: 'CAROUSEL',
        accountConfigurations: { [FEATURE_FLAGS.CREATIVE_CAROUSEL_ENABLED]: 'true' },
        visibilityCondition: ({ campaigns }) => !hasCampaignCreatives(campaigns),
        subText: (
            <FormattedMessage
                id="creative.creator.carousel.format.type.description"
                defaultMessage="Use carousel ads to tell a story, share a process, or highlight a set of products, features, or services (images & videos)"
            />
        ),
    },
    {
        id: CREATIVE_FORMAT_TYPE.VERTICAL,
        icon: VerticalSplitOutlinedIcon,
        label: 'VERTICAL',
        accountConfigurations: { [FEATURE_FLAGS.IS_VERTICAL_CREATIVE_ENABLED]: 'true' },
        subText: (
            <FormattedMessage
                id="creative.creator.vertical.format.type.description"
                defaultMessage="[BETA] Create a vertical ad with static media assets; motion ads coming soon."
            />
        ),
    },
];

export const formatTypesMap = keyBy(formatTypes, 'id');
